import { useState, useEffect, useCallback } from 'react';

/**
 * Chat-History State + CRUD.
 * Erwartet `api` (von makeApi).
 */
export default function useChats(api) {
  const [chats, setChats] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const d = await api.get('/api/chats');
      setChats(d?.chats || []);
    } catch (_) { /* offline → letzte Liste behalten */ }
  }, [api]);

  useEffect(() => { refresh(); }, [refresh]);

  const createChat = useCallback(async () => {
    try {
      const d = await api.post('/api/chats', {});
      await refresh();
      return d?.id || null;
    } catch { return null; }
  }, [api, refresh]);

  const renameChat = useCallback(async (id, title) => {
    await api.patch(`/api/chats/${id}`, { title }).catch(() => null);
    refresh();
  }, [api, refresh]);

  const deleteChat = useCallback(async (id) => {
    await api.delete(`/api/chats/${id}`).catch(() => null);
    refresh();
  }, [api, refresh]);

  const togglePin = useCallback(async (id, current) => {
    await api.patch(`/api/chats/${id}`, { pinned: current ? 0 : 1 }).catch(() => null);
    refresh();
  }, [api, refresh]);

  return { chats, refresh, createChat, renameChat, deleteChat, togglePin };
}
